// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2A0aj","title":"AfterFrontImage_title__uuFNr"};